// @flow
import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import _ from 'lodash';
import SuperSelectField from 'common/components/superselectfield/SuperSelectField';

type Entry = { value: string, label?: string };

type Props = any | {
  value: string | string[],
  multiselect: boolean,
  data: { [category: string]: Array<Entry> },
  onChange: (string | string[]) => void,
  noMatchFoundText: string,
  style?: Object,
  theme: any,
  t: any,
};

class CategorizedDropdown extends Component<Props> {
  generateItems() {
    const { data } = this.props;
    const result = [];
    _.keys(data).sort().forEach((category) => {
      const mappedValues = data[category].map(entry =>
        <div key={entry.value} value={entry.value} label={entry.label}>{entry.label || entry.value}</div>);

      if (category === 'undefined') {
        Array.prototype.unshift.apply(result, mappedValues);
        return;
      }
      result.push(<optgroup key={category} label={category}>{mappedValues}</optgroup>);
    });
    return result;
  }

  findByValue(value: string | string[]): ?Entry | Entry[] | void {
    if (this.props.multiselect) {
      return this.findByValues((value: any));
    }

    let result;
    _.forIn(this.props.data, (val) => {
      result = val.find(el => el.value === value);
      return !result;
    });
    return result;
  }

  findByValues(values: Entry[]): Entry[] {
    let results = [];
    _.forIn(this.props.data, (val) => {
      const result = val.filter(el => values.includes(el.value));

      results = results.concat(result);
    });

    return results;
  }

  onChange = (items: ?Entry | Array<Entry>) => {
    if (!items) {
      return;
    }

    if (this.props.multiselect) {
      const itemValues = (items: any).map(i => i.value);
      this.props.onChange(itemValues);
    } else {
      this.props.onChange((items: any).value);
    }
  }

  render() {
    const passThrough = _.omit(this.props, 'data', 'style', 'value');
    return (
      <SuperSelectField
        {...passThrough}
        value={this.findByValue(this.props.value)}
        onChange={this.onChange}
        showAutocompleteThreshold="always"
        elementHeight={32}
        style={{ width: 256, outline: 'none', ...this.props.style }}
        menuGroupStyle={{ color: this.props.theme.colors.dimGray, fontSize: 14 }}
        innerDivStyle={{ marginLeft: 16 }}
        hintTextAutocomplete={this.props.t('search')}
        noMatchFound={this.props.noMatchFoundText}
        multiple={this.props.multiselect}
      >
        {this.generateItems()}
      </SuperSelectField>
    );
  }
}

export default translate()(withTheme(CategorizedDropdown));



// WEBPACK FOOTER //
// ./src/common/components/CategorizedDropdown.js